class ModalElement extends HTMLElement {
  constructor() {
    super();
    this.body = document.body;
    this.modalToggle = this.querySelector('button.modal__toggle');
    this.modalContent = this.querySelector('.modal__content');
    this.modalDialog = this.querySelector('.modal__dialog');
    this.close = this.modalDialog?.querySelector(':scope > .modal__close-button');
    this.onOutsideClick = this.handleBodyClick.bind(this);


    this.debouncedOnClick = debounce((event) => {
      this.modalClose(event);
    });

    this.debouncedOnToggleClick = debounce((event) => {
      this.onToggleClick(event);
    });

    this.modalToggle?.addEventListener('click', this.debouncedOnToggleClick.bind(this));
    this.close?.addEventListener('click', this.debouncedOnClick.bind(this));
  }

  onToggleClick(event) {
    event.preventDefault();
    this.hasAttribute('open')
      ? this.modalClose(event)
      : this.open(event);
  }

  toggleHeader(visible) {
    if (!this.hasAttribute('data-hide-header')) return;

    const headerElementsWrapper = document.querySelector('.header-elements-wrapper');
    if (!headerElementsWrapper) return;

    if (visible) {
      headerElementsWrapper.classList.remove('header-hidden');
    } else {
      headerElementsWrapper.classList.add('header-hidden');
    }
  }

  open() {
    this.body.addEventListener('click', this.onOutsideClick);
    this.dispatchEvent(new CustomEvent("modal-open"));
    this.setAttribute('open', true);
    this.body.classList.add('overflow-hidden');
    this.toggleHeader(false);

    if (this.closest('.product__info-wrapper')) {
      this.closest('.product__info-wrapper').style.zIndex = 3;
    }
  }

  modalClose(event) {
    event && event.preventDefault();

    this.dispatchEvent(new CustomEvent("modal-close"));
    this.removeAttribute('open');
    this.toggleHeader(true);

    if (!this.parentElement.parentElement.classList.contains('bundle-product')) {
      this.body.classList.remove('overflow-hidden');

      if (this.closest('.product__info-wrapper')) {
        this.closest('.product__info-wrapper').style.removeProperty('z-index');
      } else if (document.querySelector('.product__info-wrapper')) {
        document.querySelector('.product__info-wrapper').style.removeProperty('z-index');
      }
    }
    this.body.removeEventListener('click', this.onOutsideClick);
  }

  handleBodyClick(event) {
    if (event.target.tagName.toLowerCase() !== 'a') {
      event.preventDefault();
      if (event.target.classList.contains('modal-overlay')) {
        if (this.hasAttribute('open') && !this.classList.contains('discount-modal')) {
          this.modalClose(event);
        }
      }
    }
  }
}

customElements.define('modal-popup', ModalElement);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}